module.exports = __webpack_public_path__ + "img/footer-logo-mobile.a6f72d8a.svg";